import {
  ImageBackground,
  StyleSheet,
  useWindowDimensions,
  SafeAreaView,
  Platform,
  Alert,
} from "react-native";
import React, { useEffect, useState } from "react";
import {
  Text,
  View,
  ScrollView,
  HStack,
  Heading,
  Button,
  Input,
  FormControl,
  Stack,
} from "native-base";
import { MaterialCommunityIcons } from "@expo/vector-icons";
import { StackScreenProps } from "../types";
import AsyncStorage from "@react-native-async-storage/async-storage";
import { kv, createClient } from "@vercel/kv";

const Admin = ({ navigation }: StackScreenProps<"Team">) => {
  const { width, height } = useWindowDimensions();

  const [data, setData] = useState({});
  const [loading, setLoading] = useState(false);

  const handleOnChange = (text: string, key: string) => {
    const old = { ...data };
    old[key] = text;

    setData(old);
  };

  const updateKeyFigures = async () => {
    setLoading(true);

    fetch(
      `https://generous-bedbug-34811.kv.vercel-storage.com/set/keyFigures/${JSON.stringify(
        data
      )}`,
      {
        headers: {
          Authorization: `Bearer AYf7ASQgNDFmYzZjY2UtZjdlMC00MTBmLTg3NmYtNzRiYjA2ZTIwYjRhMTgxM2U3MTBmMjMwNGIwNDhkYjA2Yzk3MTk4NmRjYjY=`,
        },
      }
    )
      .then((response) => response.json())
      .then((data) => {
        // console.log({ data });

        setLoading(false);

        window.alert("Updates saved successfully");
      })
      .catch((err) => {
        window.alert("Something went wrong. Please try again");
        setLoading(false);
      });
  };

  useEffect(() => {
    async function getData() {
      fetch(
        `https://generous-bedbug-34811.kv.vercel-storage.com/get/keyFigures`,
        {
          headers: {
            Authorization: `Bearer AYf7ASQgNDFmYzZjY2UtZjdlMC00MTBmLTg3NmYtNzRiYjA2ZTIwYjRhMTgxM2U3MTBmMjMwNGIwNDhkYjA2Yzk3MTk4NmRjYjY=`,
          },
        }
      )
        .then((response) => response.json())
        .then((data) => {
          if (data) {
            setData(JSON.parse(data?.result));
            AsyncStorage.setItem("keyFigures", data.result);
          }
        });
    }

    getData();
  }, []);

  return (
    <ImageBackground
      source={require("../assets/background.png")}
      resizeMode="cover"
      style={{ width, height }}
    >
      {/* <View style={styles.overlay}> */}
      <ScrollView style={styles.overlay}>
        <SafeAreaView style={{ height }}>
          <HStack
            mb={5}
            px={10}
            mt={Platform.OS == "web" ? "20" : "5"}
            alignItems={"center"}
          >
            <Button
              startIcon={
                <MaterialCommunityIcons name="arrow-left" color={"#fff"} />
              }
              // position={"absolute"}
              onPress={() => navigation.navigate("Home")}
              // left={0}
              // top={-5}
              variant={"ghost"}
            >
              Back
            </Button>

            <Heading textAlign="center" flex={1}>
              Admin
            </Heading>
          </HStack>

          <View mt={10} px={10}>
            <Text>Agripromoters Key Figures</Text>
            <HStack alignItems={"flex-end"}>
              <FormControl isRequired w={"50%"}>
                <Stack mx="4">
                  <FormControl.Label>Agripromoters</FormControl.Label>
                  <Input
                    onChangeText={(t) => handleOnChange(t, "agripromoters_1")}
                    defaultValue={data["agripromoters_1"]}
                  />
                </Stack>
              </FormControl>
              <FormControl isRequired w={"50%"}>
                <Stack mx="4">
                  <FormControl.Label>Farmers Trained</FormControl.Label>
                  <Input
                    onChangeText={(t) => handleOnChange(t, "agripromoters_2")}
                    defaultValue={data["agripromoters_2"]}
                  />
                </Stack>
              </FormControl>
            </HStack>
            <FormControl isRequired w={"50%"} mt={3}>
              <Stack mx="4">
                <FormControl.Label>Demo plots</FormControl.Label>
                <Input
                  onChangeText={(t) => handleOnChange(t, "agripromoters_3")}
                  defaultValue={data["agripromoters_3"]}
                />
              </Stack>
            </FormControl>
          </View>

          <View mt={10} px={10}>
            <Text>Farm and Fortune Hub (FFH) Key Figures</Text>
            <HStack alignItems={"flex-end"}>
              <FormControl isRequired w={"50%"}>
                <Stack mx="4">
                  <FormControl.Label>Hubs</FormControl.Label>
                  <Input
                    onChangeText={(t) => handleOnChange(t, "ffh_1")}
                    defaultValue={data["ffh_1"]}
                  />
                </Stack>
              </FormControl>
              <FormControl isRequired w={"50%"}>
                <Stack mx="4">
                  <FormControl.Label>Farmers Reached</FormControl.Label>
                  <Input
                    onChangeText={(t) => handleOnChange(t, "ffh_2")}
                    defaultValue={data["ffh_2"]}
                  />
                </Stack>
              </FormControl>
            </HStack>
            <FormControl isRequired w={"50%"} mt={3}>
              <Stack mx="4">
                <FormControl.Label>Jobs Created</FormControl.Label>
                <Input
                  onChangeText={(t) => handleOnChange(t, "ffh_3")}
                  defaultValue={data["ffh_3"]}
                />
              </Stack>
            </FormControl>
          </View>

          <View mt={10} px={10}>
            <Text>Agribooster Key Figures</Text>
            <HStack alignItems={"flex-end"}>
              <FormControl isRequired w={"50%"}>
                <Stack mx="4">
                  <FormControl.Label>Farmers Reached</FormControl.Label>
                  <Input
                    onChangeText={(t) => handleOnChange(t, "agribooster_1")}
                    defaultValue={data["agribooster_1"]}
                  />
                </Stack>
              </FormControl>
              <FormControl isRequired w={"50%"}>
                <Stack mx="4">
                  <FormControl.Label>
                    Value of Input Financing Accessed
                  </FormControl.Label>
                  <Input
                    onChangeText={(t) => handleOnChange(t, "agribooster_2")}
                    defaultValue={data["agribooster_2"]}
                    placeholder="In billions"
                  />
                </Stack>
              </FormControl>
            </HStack>
            <FormControl isRequired w={"50%"} mt={3}>
              <Stack mx="4">
                <FormControl.Label>Baseline Yield Increase</FormControl.Label>
                <Input
                  onChangeText={(t) => handleOnChange(t, "agribooster_3")}
                  defaultValue={data["agribooster_3"]}
                />
              </Stack>
            </FormControl>
          </View>

          <View mt={10} px={10}>
            <Text>Digital Key Figures</Text>
            <HStack alignItems={"flex-end"}>
              <FormControl isRequired w={"50%"}>
                <Stack mx="4">
                  <FormControl.Label>Farmers</FormControl.Label>
                  <Input
                    onChangeText={(t) => handleOnChange(t, "digital_1")}
                    defaultValue={data["digital_1"]}
                  />
                </Stack>
              </FormControl>
              <FormControl isRequired w={"50%"}>
                <Stack mx="4">
                  <FormControl.Label>Extension Farmers</FormControl.Label>
                  <Input
                    onChangeText={(t) => handleOnChange(t, "digital_2")}
                    defaultValue={data["digital_2"]}
                  />
                </Stack>
              </FormControl>
            </HStack>
            <FormControl isRequired w={"50%"} mt={3}>
              <Stack mx="4">
                <FormControl.Label>Agrodealers</FormControl.Label>
                <Input
                  onChangeText={(t) => handleOnChange(t, "digital_3")}
                  defaultValue={data["digital_3"]}
                />
              </Stack>
            </FormControl>
          </View>

          <View mt={10} px={10}>
            <Text>EMAY Key Figures</Text>
            <HStack alignItems={"flex-end"}>
              <FormControl isRequired w={"50%"}>
                <Stack mx="4">
                  <FormControl.Label>Young Leaders</FormControl.Label>
                  <Input
                    onChangeText={(t) => handleOnChange(t, "emay_1")}
                    defaultValue={data["emay_1"]}
                  />
                </Stack>
              </FormControl>
              <FormControl isRequired w={"50%"}>
                <Stack mx="4">
                  <FormControl.Label>Farmers Reached</FormControl.Label>
                  <Input
                    onChangeText={(t) => handleOnChange(t, "emay_2")}
                    defaultValue={data["emay_2"]}
                  />
                </Stack>
              </FormControl>
            </HStack>
            <FormControl isRequired w={"50%"} mt={3}>
              <Stack mx="4">
                <FormControl.Label>Soil Analysis Coverage</FormControl.Label>
                <Input
                  onChangeText={(t) => handleOnChange(t, "emay_3")}
                  defaultValue={data["emay_3"]}
                />
              </Stack>
            </FormControl>
          </View>

          <View mt={10} px={10}>
            <Text>Farm & Fortune Radio Key Figures</Text>
            <HStack alignItems={"flex-end"}>
              <FormControl isRequired w={"50%"}>
                <Stack mx="4">
                  <FormControl.Label>Listeners</FormControl.Label>
                  <Input
                    onChangeText={(t) => handleOnChange(t, "ffhradio_1")}
                    defaultValue={data["ffhradio_1"]}
                    placeholder="In millions. E.g 5 for 5million"
                  />
                </Stack>
              </FormControl>
              <FormControl isRequired w={"50%"}>
                <Stack mx="4">
                  <FormControl.Label>Episodes</FormControl.Label>
                  <Input
                    onChangeText={(t) => handleOnChange(t, "ffhradio_2")}
                    defaultValue={data["ffhradio_2"]}
                  />
                </Stack>
              </FormControl>
            </HStack>
            <FormControl isRequired w={"50%"} mt={3}>
              <Stack mx="4">
                <FormControl.Label>Local Languages</FormControl.Label>
                <Input
                  onChangeText={(t) => handleOnChange(t, "ffhradio_3")}
                  defaultValue={data["ffhradio_3"]}
                />
              </Stack>
            </FormControl>
          </View>

          <View mt={10} px={10}>
            <Text>Farm & Fortune TV Key Figures</Text>
            <HStack alignItems={"flex-end"}>
              <FormControl isRequired w={"50%"}>
                <Stack mx="4">
                  <FormControl.Label>Listeners</FormControl.Label>
                  <Input
                    onChangeText={(t) => handleOnChange(t, "ffhtv_1")}
                    defaultValue={data["ffhtv_1"]}
                  />
                </Stack>
              </FormControl>
              <FormControl isRequired w={"50%"}>
                <Stack mx="4">
                  <FormControl.Label>Episodes</FormControl.Label>
                  <Input
                    onChangeText={(t) => handleOnChange(t, "ffhtv_2")}
                    defaultValue={data["ffhtv_2"]}
                  />
                </Stack>
              </FormControl>
            </HStack>
            <FormControl isRequired w={"50%"} mt={3}>
              <Stack mx="4">
                <FormControl.Label>Crops</FormControl.Label>
                <Input
                  onChangeText={(t) => handleOnChange(t, "ffhtv_3")}
                  defaultValue={data["ffhtv_3"]}
                />
              </Stack>
            </FormControl>
          </View>

          <View mt={10} px={10}>
            <Text>Model Farm Key Figures</Text>
            <HStack alignItems={"flex-end"}>
              <FormControl isRequired w={"50%"}>
                <Stack mx="4">
                  <FormControl.Label>Farmers Reached</FormControl.Label>
                  <Input
                    onChangeText={(t) => handleOnChange(t, "modelfarm_1")}
                    defaultValue={data["modelfarm_1"]}
                  />
                </Stack>
              </FormControl>
              <FormControl isRequired w={"50%"}>
                <Stack mx="4">
                  <FormControl.Label>
                    Value of Input Financing Accessed
                  </FormControl.Label>
                  <Input
                    onChangeText={(t) => handleOnChange(t, "modelfarm_2")}
                    defaultValue={data["modelfarm_2"]}
                  />
                </Stack>
              </FormControl>
            </HStack>
            <FormControl isRequired w={"50%"} mt={3}>
              <Stack mx="4">
                <FormControl.Label>Baseline Yield Increase</FormControl.Label>
                <Input
                  onChangeText={(t) => handleOnChange(t, "modelfarm_3")}
                  defaultValue={data["modelfarm_3"]}
                />
              </Stack>
            </FormControl>
          </View>

          <View mt={10} px={10}>
            <Text>School Lab Key Figures</Text>
            <HStack alignItems={"flex-end"}>
              <FormControl isRequired w={"50%"}>
                <Stack mx="4">
                  <FormControl.Label>Farmers Reached</FormControl.Label>
                  <Input
                    onChangeText={(t) => handleOnChange(t, "schoollab_1")}
                    defaultValue={data["schoollab_1"]}
                  />
                </Stack>
              </FormControl>
              <FormControl isRequired w={"50%"}>
                <Stack mx="4">
                  <FormControl.Label>
                    Mobile Soil Testing Trucks
                  </FormControl.Label>
                  <Input
                    onChangeText={(t) => handleOnChange(t, "schoollab_2")}
                    defaultValue={data["schoollab_2"]}
                  />
                </Stack>
              </FormControl>
            </HStack>
            <FormControl isRequired w={"50%"} mt={3}>
              <Stack mx="4">
                <FormControl.Label>Jobs Created</FormControl.Label>
                <Input
                  onChangeText={(t) => handleOnChange(t, "schoollab_3")}
                  defaultValue={data["schoollab_3"]}
                />
              </Stack>
            </FormControl>
          </View>

          <Button
            w="full"
            mt={5}
            isLoading={loading}
            onPress={updateKeyFigures}
          >
            Update
          </Button>
        </SafeAreaView>
      </ScrollView>
    </ImageBackground>
  );
};

export default Admin;

const styles = StyleSheet.create({
  overlay: {
    ...StyleSheet.absoluteFillObject,
    backgroundColor: "rgba(12, 12, 12, 0.878)",
  },
  cardOverlay: {
    ...StyleSheet.absoluteFillObject,
    backgroundColor: "rgba(0, 0, 0, 0.1)",
  },
  tabBar: {
    flexDirection: "row",
    paddingTop: 20,
  },
  tabItem: {
    flex: 1,
    alignItems: "center",
    padding: 16,
  },
});
